import axios from 'axios';
import { BookingResponseDto, CancelBookingDto, CreateBookingDto, MessageResponseDto, RescheduleBookingDto, UpdateBookingDto } from '../types/booking';
import { SERVICES_API_BASE_URL } from './apiConfig';

const API_BASE = `${SERVICES_API_BASE_URL}/api/AdminBooking`;

const api = axios.create();

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const bookingApi = {
  getBookings: () => api.get<BookingResponseDto[]>(API_BASE),
  getUpcomingBookings: () => api.get<BookingResponseDto[]>(`${API_BASE}/upcoming`),
  getBooking: (bookingId: string) => api.get<BookingResponseDto>(`${API_BASE}/${bookingId}`),
  createBooking: (data: CreateBookingDto) => api.post<BookingResponseDto>(API_BASE, data),
  updateBooking: (bookingId: string, data: UpdateBookingDto) => api.put<BookingResponseDto>(`${API_BASE}/${bookingId}`, data),
  cancelBooking: (bookingId: string, data: CancelBookingDto) => api.post<MessageResponseDto>(`${API_BASE}/${bookingId}/cancel`, data),
  rescheduleBooking: (bookingId: string, data: RescheduleBookingDto) => api.post<BookingResponseDto>(`${API_BASE}/${bookingId}/reschedule`, data),
  completeBooking: (bookingId: string) => api.post<BookingResponseDto>(`${API_BASE}/${bookingId}/complete`),
  deleteBooking: (bookingId: string) => api.delete<MessageResponseDto>(`${API_BASE}/${bookingId}`),
};

